<template>
    <modal id="create-projects-modal">
        <template slot="title">Purchase Project</template>
        <template slot="body">

            <div class="form-group">
                <label>Select number of projects</label>
                <select v-model="form.selected_package" class="form-control">
                    <option :value="null">Select option...</option>
                    <option v-for="item in packages" :value="item" :key="item.id" v-text="item.name"></option>
                </select>
            </div>

            <search-user v-if="authorize('admin')" filter="employers" placeholder="Employer" v-model="form.user_id" @user="setSelectedUser"></search-user>

            <div class="form-group" v-if="authorize('admin') && form.selected_package">
                <label>
                    <input type="checkbox" v-model="form.withPayment"> With Payment
                </label>
            </div>

            <div v-if="form.selected_package && form.withPayment" class="payment">

                <h3 v-text="form.selected_package.price"></h3>

                <div v-if="billingTo && billingTo.has_billing_info_on_file" class="card-info">
                    <div class="card-item card-brand" :class="billingTo.pm_type">
                        <i :class="cardBrand"></i>
                    </div>
                    <div class="card-item card-last-four"
                         v-text="billingTo.pm_last_four"></div>
                </div>

            </div>



        </template>
        <template slot="footer">

            <button class="btn btn-default" @click="closeModal('create-projects-modal')">Cancel</button>

            <button class="btn btn-success" @click.prevent="save()" :disabled="(!form.selected_package || form.isSubmitted)">
                <span v-if="form.isSubmitted">
                    <i class="fa fa-spinner fa-spin"></i> Processing....
                </span>
                <span v-else>Checkout</span>
            </button>

        </template>
    </modal>
</template>
<script>
    export default {

        props:{
            authUser:{
                type: Object,
                required: true,
            },
            packages: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                selectedUser: null,
                form: new Form({
                    user_id: null,
                    selected_package: null,
                    withPayment: true,
                    stripeToken: null
                }),
            }
        },

        methods:{

            save() {
                this.form.post(`/projects/create`).then(response => {
                    if(response.status == true){
                        Alert.withAction('Thank you for your purchase<br> Your projects will be available right away').then(() => {
                            this.refreshPage()
                        })
                    }else{
                        Alert.error(response.error)
                    }
                }).catch(error => {
                    Alert.error(error.first())
                })
            },

            setSelectedUser(user) {
                this.selectedUser = user;
            }
        },

        computed:{
            billingTo(){
                if(this.selectedUser) return this.selectedUser;
                return this.authUser;
            },

            cardBrand(){
                if(this.billingTo.pm_type == 'amex') return 'fab fa-cc-amex';
                return `fab fa-cc-${this.billingTo.pm_type.toLowerCase()}`
            }
        }

    }
</script>
